<template>
    <v-dialog v-model="dialogCreate" persistent max-width="75%">
        <v-card class="v-card--dialog">
            <v-card-title class="headline">Добавить новый текстовый блок</v-card-title>
            <v-card-text>
                <v-form>
                    <v-layout flex wrap>
                        <v-flex xs4>
                            <upload-img :image-width="445" :image-height="582" v-model="textBlock.img"
                                        :content-area="12">
                                <div slot="activator">
                                    <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-if="!textBlock.img">
                                        <img src="/static/img/media/text_block_blank.svg"
                                             alt="Нажмите чтобы добавить картинку для текстового блока"/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple tile v-else>
                                        <img :src="textBlock.img.imageURL" alt="Изображение для текстового блока"/>
                                    </v-avatar>
                                </div>
                            </upload-img>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs7>
                            <v-subheader class="pa-0">Название</v-subheader>
                            <v-text-field
                                ref="textBlock_title"
                                v-model="textBlock.title"
                                v-validate="'required|max:255'"
                                data-vv-name="title"
                                :error-messages="errors.collect('title')"
                                single-line
                                text
                                solo
                                required/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-switch v-model="textBlock.status"
                                      :label="`${(textBlock.status) ? 'Активен' : 'Не активен' }`"/>
                            <v-subheader class="pa-0">Описание</v-subheader>
                            <v-textarea
                                ref="textBlock_text"
                                v-model="textBlock.text"
                                v-validate="'required|max:255'"
                                data-vv-name="text"
                                :error-messages="errors.collect('text')"
                                text
                                solo
                                required
                                counter="255"/>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click.native="onClose">Отмена</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import UploadImg from '../../../components/Media/Upload'
    import TextBlock from '../../../api/textblock'

    export default {
        name: 'addTextBlock',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        props: ['dialogCreate', 'onClose'],
        data: () => ({
            loading: false,
            textBlock: {
                title: '',
                text: '',
                img: '',
                status: true
            },
            dictionary: {
                custom: {
                    title: {
                        required: 'Введите тайтл для слайдера',
                        max: 'Превышено максимальное количество символов'
                    },
                    text: {
                        required: 'Описание не заполнено',
                        max: 'Превышено максимальное количество символов'
                    }
                }
            }
        }),
        watch: {
            dialogCreate (value) {
                if (!value) this.onClose()
            }
        },
        methods: {
            save () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true
                        TextBlock
                            .add(this.textBlock)
                            .then(response => {
                                this.$store.commit('showSnackbar', {
                                    'text': response.data.data,
                                    color: 'success'
                                })
                                this.onClose()
                            })
                            .catch(error => this.$store.commit('showSnackbar', { 'text': error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        },
    }
</script>
